import { useState } from "react";
import styled from "styled-components";

import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";

const TextAviso = styled.h2`
    text-align: center;
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    color: #a50000;
`
const TextConfirm = styled.p`
    text-align: center;
    margin: 10px 0;
    font-size: 14px;
    font-weight: normal;
    color: #333;
`
const BotoesContainer = styled.div`
    width: 100%;
    height: 35px;
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
`
const BotaoConfirm = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    background-color: #DC2625;
    color: white;
    font-size: 14px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    transition: all .3s;
    font-weight: bold;
    &:hover{
        scale: 1.05;
    }
    &:disabled{
        opacity: 0.7;
        cursor: not-allowed;
        scale: 1;
    }
`
const BotaoCancelar = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    background-color: #fff;
    color: #333;
    font-size: 14px;
    border: 1px solid rgba(51, 51, 51, 0.4);
    border-radius: 7px;
    cursor: pointer;
    transition: all .3s;
    font-weight: bold;
    &:hover{
        scale: 1.05;
    }
    &:disabled{
        opacity: 0.7;
        cursor: not-allowed;
        scale: 1;
    }
`

const ModalDeleteChecklist = ({ checklist, fetchSuccess, fecharModal }) => {

    const api = useApi();

    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {

        if (!checklist?.id) return;

        setLoading(true);

        try {

            await api.delete(`/Painel/API/Checklist/SoftDeleteChecklist/index.php?id=${checklist.id}`);
            await fetchSuccess?.();
            fecharModal?.();

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    return (
        <Overlay state={true}>
            <Modal size="sm">
                <TextAviso>Apagar checklist</TextAviso>
                <TextConfirm>
                    Tem certeza que deseja apagar o checklist {checklist?.id ? `#${checklist.id}` : ''}
                    {checklist?.tipo ? ` (${checklist.tipo})` : ''}?
                </TextConfirm>
                <BotoesContainer>
                    <BotaoCancelar onClick={fecharModal} disabled={loading}>
                        CANCELAR
                    </BotaoCancelar>
                    <BotaoConfirm onClick={handleDelete} disabled={loading}>
                        {loading ? "APAGANDO..." : "APAGAR"}
                    </BotaoConfirm>
                </BotoesContainer>
            </Modal>
        </Overlay>
    )

}

export default ModalDeleteChecklist;
